export default function createImage(name) {
  return {
    name,
    url: name,
  };
}
